/**
 * صفحة الألعاب العامة — رمز الدخول (4 أرقام).
 * عيّن في الإنتاج: REACT_APP_PUBLIC_GAMES_PIN=1234 في ملف .env
 */
export const PUBLIC_GAMES_SESSION_KEY = 'esoroban_public_games_unlocked_v1';

export function getConfiguredPublicGamesPin() {
  const raw = process.env.REACT_APP_PUBLIC_GAMES_PIN;
  const digits = raw != null && String(raw).trim() !== '' ? String(raw).replace(/\D/g, '').slice(0, 4) : '';
  if (digits.length === 4) return digits;
  if (process.env.NODE_ENV === 'development') {
    return '0000';
  }
  return '0000';
}
